import * as UT from "./tradeTypes";

const initialState = {
  trades: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UT.USER_REQUEST:
      return {
        ...state,
      };
    case UT.USER_SUCCESS:
      return {
        trades: action.payload,
        error: "",
      };
    case UT.USER_SAVED_SUCCESS:
      return {
        message: action.payload,
        error: "",
      };
    case UT.USER_FAILURE:
      return {
        trades: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
